import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RoleTypes } from '../../../_core/access-control-mgt/models/user-role.model';
import { carmPermissionsKey , RoleTypePermissionState } from '../reducers/role-type-permission.reducer';

export const selectRoleTypePermissionState = createFeatureSelector<RoleTypePermissionState>(
  carmPermissionsKey,
);

/** This selector return either permission already exist in the state or not */
export const isRoleTypePermissionExist = createSelector(
  selectRoleTypePermissionState,
  (state: RoleTypePermissionState, props: {roleType: RoleTypes}) =>  {
      if ( state && state.roleTypePermissions && state.roleTypePermissions.length > 0) {
        return  state.roleTypePermissions.findIndex((element) => element.roleType === props.roleType) > -1;
      } else {
        return false;
      }
  },
);


export const getRoleTypePermission = createSelector(
  selectRoleTypePermissionState,
  (state: RoleTypePermissionState, props: {roleType: RoleTypes}) =>  {
      if ( state && state.roleTypePermissions && state.roleTypePermissions.length > 0) {
        return  state.roleTypePermissions.find((element) => element.roleType === props.roleType);
      } else {
        return null;
      }
  },
);

export const getAllRolePermissions = createSelector(
  selectRoleTypePermissionState,
  (state: RoleTypePermissionState) =>  {
      if ( state && state.roleTypePermissions && state.roleTypePermissions.length > 0) {
        return  state.roleTypePermissions;
      } else {
        return null;
      }
  },
);

export const getProgramPermissions = createSelector(
  selectRoleTypePermissionState,
  (state: RoleTypePermissionState) =>  {
      if ( state && state.permissions && state.permissions.length > 0) {
        return  state.permissions;
      } else {
        return null;
      }
  },
);

export const getNativeBusinessPermissions = createSelector(
  selectRoleTypePermissionState,
  (state: RoleTypePermissionState) =>  {
      if ( state && state.nativePermissions && state.nativePermissions.length > 0) {
        return  state.nativePermissions;
      } else {
        return null;
      }
  },
);

export const isRoleTypePermissionLoaded = createSelector(
  selectRoleTypePermissionState,
  (state: RoleTypePermissionState) => state && !state.loading && state.success
);

